var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-4" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "right-inner-addon" }, [
        _c("i", { staticClass: "fa fa-search" }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query",
            },
          ],
          staticClass: "form-control search-lists",
          attrs: {
            id: "drip-campaign-search-id",
            type: "search",
            placeholder: _vm.$t("drip-campaigns.actions.searchFor"),
            autocomplete: "off",
          },
          domProps: { value: _vm.query },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.query = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { attrs: { for: "drip-campaign-search-id", hidden: "true" } },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("drip-campaigns.actions.searchFor")) +
                "\n      "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }